/* eslint-disable react/forbid-prop-types */

/* eslint-disable react/prop-types */

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
import PropTypes from 'prop-types';
import { ModalDialogStyle } from './overwriteStyle';
import style from './ModalDialog.module.css';
const { withStyles } = MaterialUiCore;
const { DialogTitle } = MaterialUiCore;
const { DialogContent } = MaterialUiCore;
const { Dialog } = MaterialUiCore;
export const styles = () => ModalDialogStyle;

function ModalDialog({ children, open, handleClose, title, classes }) {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className={classes.root}
        >
            <DialogTitle id="alert-dialog-title">
                <div className={style.modalTitle}>
                    <span>{title}</span>
                    <span onClick={handleClose} className="sct-icons icon-Remove-18 icon-text-18" />
                </div>
            </DialogTitle>
            <DialogContent>{children}</DialogContent>
        </Dialog>
    );
}

ModalDialog.propTypes = {
    children: PropTypes.shape({}).isRequired,
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    title: PropTypes.any.isRequired,
};
export default withStyles(styles)(ModalDialog);
export { ModalDialog };
